import { render } from "./LotApproveButton.vue?vue&type=template&id=73c8aed4&scoped=true&ts=true&lang=pug"
import script from "./LotApproveButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotApproveButton.vue?vue&type=script&lang=ts&setup=true"

import "./LotApproveButton.vue?vue&type=style&index=0&id=73c8aed4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c8aed4"]])

export default __exports__